module.exports = __webpack_public_path__ + "static/sport/register-2.b9fb907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/form/register-2.png
// module id = EhdE
// module chunks = 0